module.exports = {"en-US":{"components":{"paginator":{"first":"Start","prev":"Previous","next":"Next","last":"End"}}}}